<p-toast></p-toast>

<p-blockUI [blocked]="isLoading">
    <div class="fixed top-0 left-0 w-full h-full flex align-items-center justify-content-center z-5"
        style="background: rgba(0,0,0,0.3);">
        <i class="pi pi-spinner pi-spin" style="font-size: 2rem; color: #000"></i>
    </div>
</p-blockUI>

<div [formGroup]="awardsForm" class="awards-container">

    <!-- Yes/No Toggle -->
    <div class="ts-elp-question mb-4">
        <label class="ts-elp-label">
            DO YOU WISH TO SHARE DETAILS ABOUT ANY AWARD/ACHIEVEMENTS?
            <span class="ts-required">*</span>
        </label>
        <div class="ts-toggle-group" style="height: 35px;">
            <button type="button" class="ts-toggle-btn"
                [class.active]="awardsForm.get('wantsToShare')?.value === true"
                (click)="awardsForm.get('wantsToShare')?.setValue(true)">Yes</button>
            <button type="button" class="ts-toggle-btn"
                [class.active]="awardsForm.get('wantsToShare')?.value === false"
                (click)="awardsForm.get('wantsToShare')?.setValue(false)">No</button>
        </div>
    </div>

    <!-- Yes Branch: Achievement Entries -->
    <div *ngIf="wantsToShare" formArrayName="entries">
        <div *ngFor="let entry of entries.controls; let i = index"
             [formGroupName]="i"
             class="achievement-card mb-4">

            <!-- Card Header -->
            <div class="card-header mb-3">
                <span class="card-label">ACHIEVEMENT</span>
                <button pButton type="button" icon="pi pi-trash"  *ngIf="i >= 1"
                    class="p-button-danger p-button-text p-button-sm remove-btn-header"
                    (click)="removeEntry(i)">
                </button>
            </div>

            <!-- Achievement Type -->
            <div class="form-group full-width mb-3">
                <label class="field-label">SELECT ACHIEVEMENT TYPE <span class="req">*</span></label>
                <p-dropdown
                    [options]="categoryOptions"
                    formControlName="category"
                    styleClass="w-full"
                    placeholder="e.g. Sports, Academic, Leadership..."
                    [showClear]="true"
                    [ngClass]="{'ng-invalid ng-touched': entry.get('category')?.invalid && entry.get('category')?.touched}">
                </p-dropdown>
                <small *ngIf="entry.get('category')?.invalid && entry.get('category')?.touched"
                    class="error-msg">Please select an achievement type</small>
            </div>

            <!-- Conditional Fields -->
            <ng-container *ngIf="entry.get('category')?.value !== null && entry.get('category')?.value !== undefined">

                <!-- Row: Award Name + optional second field -->
                <!-- 
                    Categories with a second field: 1=Sports(issuingBody), 3=Leadership(responsibility), 4=SocialWork(organisation)
                    Categories with NO second field: 2=Academic, 5=Competitions, 6=Others → Award Name goes full width
                -->
                <div class="form-row mb-3"
                    [class.two-col]="hasSecondField(entry.get('category')?.value)"
                    [class.one-col]="!hasSecondField(entry.get('category')?.value)">

                    <!-- Award Name: full width when no sibling -->
                    <div class="form-group">
                        <label class="field-label">
                            <span [ngSwitch]="entry.get('category')?.value">
                                <span *ngSwitchCase="1">AWARD NAME</span>
                                <span *ngSwitchCase="2">AWARD NAME</span>
                                <span *ngSwitchCase="3">LEADERSHIP ROLE / AWARD</span>
                                <span *ngSwitchCase="4">ACTIVITY / AWARD NAME</span>
                                <span *ngSwitchCase="5">COMPETITION NAME</span>
                                <span *ngSwitchDefault>AWARD / ACTIVITY NAME</span>
                            </span>
                            <span class="req">*</span>
                        </label>
                        <input pInputText formControlName="awardName"
                            placeholder="Enter award/activity name"
                            class="w-full"
                            [ngClass]="{'ng-invalid ng-touched': entry.get('awardName')?.invalid && entry.get('awardName')?.touched}" />
                        <small *ngIf="entry.get('awardName')?.hasError('required') && entry.get('awardName')?.touched"
                            class="error-msg">Award name is required</small>
                        <small *ngIf="entry.get('awardName')?.hasError('minlength') && entry.get('awardName')?.touched"
                            class="error-msg">Award name must be at least 2 characters</small>
                        <small *ngIf="entry.get('awardName')?.hasError('pattern') && entry.get('awardName')?.touched"
                            class="error-msg">Invalid format, only alphabets are allowed</small>
                    </div>

                    <!-- Issuing Body (Sports only) -->
                    <div class="form-group" *ngIf="entry.get('category')?.value === 1">
                        <label class="field-label">ISSUING BODY <span class="req">*</span></label>
                        <input pInputText formControlName="issuingBody"
                            placeholder="e.g. Federation / Board name" class="w-full"
                            [ngClass]="{'ng-invalid ng-touched': entry.get('issuingBody')?.hasError('pattern') && entry.get('issuingBody')?.touched}" />
                        <small *ngIf="entry.get('issuingBody')?.hasError('pattern') && entry.get('issuingBody')?.touched"
                            class="error-msg">Invalid format, only alphabets are allowed</small>
                    </div>

                    <!-- Organisation (Social Work only) -->
                    <div class="form-group" *ngIf="entry.get('category')?.value === 4">
                        <label class="field-label">ORGANISATION / CAUSE</label>
                        <input pInputText formControlName="organisation"
                            placeholder="e.g. NGO Name or Cause" class="w-full"
                            [ngClass]="{'ng-invalid ng-touched': entry.get('organisation')?.hasError('pattern') && entry.get('organisation')?.touched}" />
                        <small *ngIf="entry.get('organisation')?.hasError('pattern') && entry.get('organisation')?.touched"
                            class="error-msg">Invalid format, only alphabets are allowed</small>
                    </div>

                    <!-- Responsibility (Leadership only) -->
                    <div class="form-group" *ngIf="entry.get('category')?.value === 3">
                        <label class="field-label">RESPONSIBILITY</label>
                        <input pInputText formControlName="responsibility"
                            placeholder="e.g. Led a team of 50 students" class="w-full"
                            [ngClass]="{'ng-invalid ng-touched': entry.get('responsibility')?.hasError('pattern') && entry.get('responsibility')?.touched}" />
                        <small *ngIf="entry.get('responsibility')?.hasError('pattern') && entry.get('responsibility')?.touched"
                            class="error-msg">Invalid format, only alphabets are allowed</small>
                    </div>

                </div>

                <!-- Level (always full width) -->
                <div class="form-group full-width mb-3">
                    <label class="field-label">LEVEL <span class="req">*</span></label>
                    <!-- hidden input to satisfy any reactive form binding if needed -->
                    <input pInputText formControlName="level" class="w-full" style="display:none" />
                    <p-dropdown
                        [options]="levelOptions"
                        formControlName="level"
                        styleClass="w-full"
                        placeholder="Select level"
                        [showClear]="true"
                        [ngClass]="{'ng-invalid ng-touched': entry.get('level')?.invalid && entry.get('level')?.touched}">
                    </p-dropdown>
                    <small *ngIf="entry.get('level')?.invalid && entry.get('level')?.touched"
                        class="error-msg">Please select a level</small>
                </div>

                <!-- Extra fields row (Leadership / Social Work / Others) — always full width since single field -->
                <ng-container
                    *ngIf="entry.get('category')?.value === 4 || entry.get('category')?.value === 3 || entry.get('category')?.value === 6">

                    <div class="form-group full-width mb-3" *ngIf="entry.get('category')?.value === 4">
                        <label class="field-label">IMPACT</label>
                        <input pInputText formControlName="impact"
                            placeholder="e.g. Helped 200+ students" class="w-full"
                            [ngClass]="{'ng-invalid ng-touched': entry.get('impact')?.hasError('pattern') && entry.get('impact')?.touched}" />
                        <small *ngIf="entry.get('impact')?.hasError('pattern') && entry.get('impact')?.touched"
                            class="error-msg">Invalid format, only alphabets are allowed</small>
                    </div>

                    <div class="form-group full-width mb-3" *ngIf="entry.get('category')?.value === 3">
                        <label class="field-label">KEY ACHIEVEMENTS</label>
                        <input pInputText formControlName="keyAchievements"
                            placeholder="e.g. Organised annual school fest" class="w-full"
                            [ngClass]="{'ng-invalid ng-touched': entry.get('keyAchievements')?.hasError('pattern') && entry.get('keyAchievements')?.touched}" />
                        <small *ngIf="entry.get('keyAchievements')?.hasError('pattern') && entry.get('keyAchievements')?.touched"
                            class="error-msg">Invalid format, only alphabets are allowed</small>
                    </div>

                    <div class="form-group full-width mb-3" *ngIf="entry.get('category')?.value === 6">
                        <label class="field-label">PLEASE SPECIFY</label>
                        <input pInputText formControlName="specify"
                            placeholder="Describe the type of activity or award" class="w-full"
                            [ngClass]="{'ng-invalid ng-touched': entry.get('specify')?.hasError('pattern') && entry.get('specify')?.touched}" />
                        <small *ngIf="entry.get('specify')?.hasError('pattern') && entry.get('specify')?.touched"
                            class="error-msg">Invalid format, only alphabets are allowed</small>
                    </div>

                </ng-container>

                <!-- Description (always full width) -->
                <div class="form-group full-width mb-3">
                    <label class="field-label">
                        DESCRIBE YOUR ACHIEVEMENT <span class="req">*</span>
                        <span class="field-hint">(min 10 words, max 500 words)</span>
                    </label>
                    <textarea pInputTextarea formControlName="description" rows="4"
                        placeholder="Tell us what you achieved, your role and the impact"
                        class="w-full"
                        [ngClass]="{'ng-invalid ng-touched': entry.get('description')?.invalid && entry.get('description')?.touched}"></textarea>
                    <small *ngIf="entry.get('description')?.hasError('required') && entry.get('description')?.touched"
                        class="error-msg">Description is required</small>
                    <small *ngIf="entry.get('description')?.hasError('minlength') && entry.get('description')?.touched"
                        class="error-msg">Description must be at least 10 characters</small>
                    <small *ngIf="entry.get('description')?.hasError('maxlength')"
                        class="error-msg">Description cannot exceed 3000 characters</small>
                </div>

                <!-- Upload Banner (always shown once category is selected) -->
                <div class="w-full mb-3 upload-banner">
                    <span class="upload-banner-text">
                            UPLOAD {{ getCategoryLabel(entry.get('category')?.value) }}  DOCUMENT&nbsp;
                            <span class="field-hint">(Certificate / Proof / Badge)</span>
                        </span>

                    <div class="flex align-items-center">

                        <!-- Upload Button -->
                        <p-fileUpload
                            class="file-upload-button1"
                            *ngIf="!hasFiles(i)"
                            mode="basic"
                            chooseLabel="Upload file"
                            chooseIcon="pi pi-upload"
                            [auto]="true"
                            (onSelect)="onFileUpload($event, i)"
                            styleClass="file-upload-btn"
                            accept=".pdf,.jpg,.jpeg,.png">
                        </p-fileUpload>

                        <!-- Uploaded File Pill -->
                        <div *ngIf="hasFiles(i)"
                            class="uploaded-file-pill flex align-items-center gap-2">
                            <i class="pi pi-file upload-file-icon cursor-pointer"
                                (click)="openPreview(getUploadedFiles(i)[0])"></i>
                            <span class="uploaded-file-name cursor-pointer"
                                (click)="openPreview(getUploadedFiles(i)[0])">
                                {{ getCategoryLabel(entry.get('category')?.value) }} Document
                            </span>
                            <button pButton type="button" icon="pi pi-times"
                                class="p-button-rounded p-button-danger p-button-text uploaded-file-remove"
                                (click)="removeFileObj(i)">
                            </button>
                        </div>
                    </div>

                    
                </div>
                <small *ngIf="entry.get('cvFiles')?.hasError('required') && entry.get('cvFiles')?.touched"
                        class="p-error block mt-2 mb-2">Supporting document is required</small>
            </ng-container>

            <!-- Save / Update Button -->
            <div class="flex flex-column align-items-end mt-4 gap-1">
                <button pButton type="button"
                    [label]="existingIds[i] ? 'Update' : 'Save'"
                    [icon]="(savingStates[i] && savingStates[i].saving) ? 'pi pi-check' : 'pi pi-check'"
                    [disabled]="savingStates[i].saving"
                    class="p-button-sm p-button-primary border-round-lg font-semibold px-4 save-button"
                    (click)="saveEntry(i)">
                </button>
                <p class="text-xs text-red-500 m-0 p-0" *ngIf="entry.dirty">
                    You have unsaved changes. Please click {{ existingIds[i] ? 'Update' : 'Save' }} to continue.
                </p>
            </div>

        </div>

        <!-- Add Another Achievement -->
        <div class="mt-3 mb-2">
            <button pButton type="button" label="+ Add Another Experience"
                class="add-achievement-btn w-full justify-content-center"
                (click)="addEntry()">
            </button>
        </div>
    </div>

    <!-- No Branch: Empty State -->
    <div *ngIf="awardsForm.get('wantsToShare')?.value === false" class="empty-state">
        <i class="pi pi-info-circle text-4xl mb-3 block"></i>
        <span>No achievements added. You can proceed if you don't have any to share.</span>
    </div>

</div>

<!-- Confirmation Dialog -->
<p-confirmDialog [style]="{width: '450px'}" styleClass="custom-delete-dialog"></p-confirmDialog>

<!-- Hidden File Input -->
<input type="file" #hiddenFileInput style="display: none;"
    (change)="onHiddenFileChange($event)"
    accept="image/*,application/pdf">

<!-- Preview Dialog -->
<p-dialog [(visible)]="displayPreviewDialog" [modal]="true" header="File Preview"
    [dismissableMask]="true"
    [style]="{width: 'auto', 'max-width': '90vw', 'min-width': '50vw'}">
    <div class="text-center p-4 relative" *ngIf="selectedPreviewItem" style="min-height: 250px;">
        <div *ngIf="isPreviewLoading"
            class="absolute top-0 left-0 w-full h-full flex flex-column align-items-center justify-content-center z-2 bg-white-alpha-60">
            <i class="pi pi-spinner pi-spin text-4xl text-primary mb-3"></i>
            <span class="text-600 font-medium font-bold">Loading preview...</span>
        </div>
        <img *ngIf="selectedPreviewItem.type && selectedPreviewItem.type.startsWith('image/')"
            [src]="selectedPreviewItem.previewUrl"
            style="max-width: 100%; max-height: 80vh; border-radius: 8px; margin: 0 auto;"
            (load)="onPreviewLoad()" (error)="onPreviewLoad()">
        <iframe *ngIf="selectedPreviewItem.type === 'application/pdf' && safePdfUrl"
            [src]="safePdfUrl" width="100%" height="600px"
            style="border: none; border-radius: 8px;" (load)="onPreviewLoad()">
        </iframe>
        <div *ngIf="!selectedPreviewItem.type || (!selectedPreviewItem.type.startsWith('image/') && selectedPreviewItem.type !== 'application/pdf')"
            class="p-5 flex flex-column align-items-center justify-content-center" style="min-width: 300px">
            <i class="pi pi-file mb-3" style="font-size: 4rem; color: #6366f1"></i>
            <h3 class="text-xl text-800 mb-3">Preview not available</h3>
            <p class="text-600 mb-4">{{ selectedPreviewItem.name }}</p>
            <a *ngIf="isString(selectedPreviewItem.previewUrl)"
                [href]="selectedPreviewItem.previewUrl"
                [download]="selectedPreviewItem.name"
                pButton label="Download to View" icon="pi pi-download"
                class="p-button-outlined"></a>
        </div>
    </div>
</p-dialog>